import { thresholdValue } from '@/editor/math/const';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { LineSeg2d } from '@/editor/math/LineSeg2d';
import { Point2dUtils } from '@/editor/math/Point2dUtils';

/*
查找 点在sortedSplitPoints中对应的区间, 范围-1到sortedSplitPoints.length-1
sortedSplitPoints需要在同一直线上
如果点在sortedSplitPoints的左侧，则返回-1
如果点在sortedSplitPoints的右侧，则返回sortedSplitPoints.length-1
如果点在sortedSplitPoints的中间，则返回点在sortedSplitPoints中的索引
如果刚好重合，返回对应索引
*/
export function getRangeIndex(sortedSplitPoints: IPoint2d[], point: IPoint2d) {
  if (sortedSplitPoints.length < 2) return null;

  const direction = new LineSeg2d(
    sortedSplitPoints[0],
    sortedSplitPoints[sortedSplitPoints.length - 1]
  ).getDirectionVector();

  let index = null;
  for (let i = 0; i < sortedSplitPoints.length; i++) {
    const startProjectDistance = Point2dUtils.projectScalar(
      Point2dUtils.subtracted(point, sortedSplitPoints[i]),
      direction
    );

    if (Math.abs(startProjectDistance) < thresholdValue) {
      index = i === 0 ? 0 : i - 1;
      break;
    } else if (startProjectDistance < 0) {
      index = i - 1;
      break;
    }
  }

  return index;
}
